module.exports = __webpack_public_path__ + "img/chart.8b44538d.jpg";